import {
  AuthIcon,
  DenoiseIcon,
  RadioWaveIcon,
  RoomIcon,
  ScanIcon,
  TrafficManagementIcon,
  UCmtyActivityIcon,
  VlanIcon,
} from "@ubnt/icons";
import { IFeatureGridCategory } from "components/OverviewPage/OverviewPage.types";
import React from "react";

import spectralRadioAnalyzerMp4 from "../assets/feature-cards/spectral-radio-analyzer.mp4";
import spectralRadioAnalyzerJpg from "../assets/feature-cards/spectral-radio-analyzer.jpg";
import prismMp4 from "../assets/feature-cards/prism.mp4";
import prismJpg from "../assets/feature-cards/prism.jpg";
import mloMp4 from "../assets/feature-cards/mlo.mp4";
import mloJpg from "../assets/feature-cards/mlo.jpg";
import puncturingMp4 from "../assets/feature-cards/puncturing.mp4";
import puncturingJpg from "../assets/feature-cards/puncturing.jpg";
import coverageVisualizationMp4 from "../assets/feature-cards/coverage-visualization.mp4";
import coverageVisualizationJpg from "../assets/feature-cards/coverage-visualization.jpg";
import radioControlsMp4 from "../assets/feature-cards/radio-controls.mp4";
import radioControlsJpg from "../assets/feature-cards/radio-controls.jpg";
import vlanConfigurationMp4 from "../assets/feature-cards/vlan-configuration.mp4";
import vlanConfigurationJpg from "../assets/feature-cards/vlan-configuration.jpg";
import flexibleAuthenticationMp4 from "../assets/feature-cards/flexible-authentication.mp4";
import flexibleAuthenticationJpg from "../assets/feature-cards/flexible-authentication.jpg";

export enum ProductCategoryId {
  WiFi = "wifi",
  Switching = "switching",
  CloudGateways = "cloudGateways",
  PhysicalSecurity = "physicalSecurity",
}

export enum ProductFeatureItem {
  DedicatedSpectralAnalyzer = "dedicatedSpectralAnalyzer",
  PrismRfFiltering = "prismRfFiltering",
  MLO = "mlo",
  Puncturing = "puncturing",
  CoverageVisualization = "coverageVisualization",
  PreciseRadioControls = "preciseRadioControls",
  VlanConfigurations = "vlanConfigurations",
  FlexibleAuthSupport = "flexibleAuthSupport",
}

export interface IFeatureGridBlock {
  id: string;
  title: string;
  category: string;
  description: string;
  video: IFeatureBlockVideo;
}

export interface IFeatureBlockVideo {
  src: string;
  poster: string;
}

export const WIFI_FEATURE_OVERVIEW_TILES = {
  id: ProductCategoryId.WiFi,
  title: "featureGrid.wifi.title",
  description: "featureGrid.wifi.description",
  blocks: [
    {
      id: ProductFeatureItem.DedicatedSpectralAnalyzer,
      title: "featureGrid.spectralAnalyzerRadio.title",
      description: "featureGrid.spectralAnalyzerRadio.description",
      variant: "light",
      assets: {
        src: spectralRadioAnalyzerMp4,
        icon: <ScanIcon size={50} color="#3B3F45" />,
        poster: spectralRadioAnalyzerJpg,
      },
    },
    {
      id: ProductFeatureItem.PrismRfFiltering,
      title: "featureGrid.prismRfFiltering.title",
      description: "featureGrid.prismRfFiltering.description",
      variant: "light",
      assets: {
        src: prismMp4,
        icon: <DenoiseIcon size={50} color="#3B3F45" />,
        poster: prismJpg,
      },
    },
    {
      id: ProductFeatureItem.MLO,
      title: "featureGrid.mlo.title",
      description: "featureGrid.mlo.description",
      variant: "light",
      assets: {
        src: mloMp4,
        icon: <TrafficManagementIcon size={50} color="#3B3F45" />,
        poster: mloJpg,
      },
    },
    {
      id: ProductFeatureItem.Puncturing,
      title: "featureGrid.puncturing.title",
      description: "featureGrid.puncturing.description",
      variant: "light",
      assets: {
        src: puncturingMp4,
        icon: <UCmtyActivityIcon size={50} color="#3B3F45" />,
        poster: puncturingJpg,
      },
    },
    {
      id: ProductFeatureItem.CoverageVisualization,
      title: "featureGrid.coverageVisualization.title",
      description: "featureGrid.coverageVisualization.description",
      variant: "light",
      assets: {
        src: coverageVisualizationMp4,
        icon: <RoomIcon size={50} color="#3B3F45" />,
        poster: coverageVisualizationJpg,
      },
    },
    {
      id: ProductFeatureItem.PreciseRadioControls,
      title: "featureGrid.preciseRadioControls.title",
      description: "featureGrid.preciseRadioControls.description",
      variant: "light",
      assets: {
        src: radioControlsMp4,
        icon: <RadioWaveIcon size={50} color="#3B3F45" />,
        poster: radioControlsJpg,
      },
    },
    {
      id: ProductFeatureItem.VlanConfigurations,
      title: "featureGrid.vlanConfigurations.title",
      description: "featureGrid.vlanConfigurations.description",
      variant: "light",
      assets: {
        src: vlanConfigurationMp4,
        icon: <VlanIcon size={50} color="#3B3F45" />,
        poster: vlanConfigurationJpg,
      },
    },
    {
      id: ProductFeatureItem.FlexibleAuthSupport,
      title: "featureGrid.flexibleAuthSupport.title",
      description: "featureGrid.flexibleAuthSupport.description",
      variant: "light",
      assets: {
        src: flexibleAuthenticationMp4,
        icon: <AuthIcon size={50} color="#3B3F45" />,
        poster: flexibleAuthenticationJpg,
      },
    },
  ],
} satisfies IFeatureGridCategory;
